var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "40px",
    viewBox: "0 0 187 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo/L/V03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/L/V03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7989899,-5.80868686e-13 L39.7989899,39.5979797 L20,19.7989899 L39.7989899,-5.80868686e-13 Z",
    id: "Combined-Shape",
    fill: "#2CB0C7",
    transform: "translate(29.899495, 19.798990) scale(-1, 1) translate(-29.899495, -19.798990) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.125,1.72258006 L26.8485174,19.9999892 L45.125,38.2764719 L45.125,1.72258006 Z",
    id: "Combined-Shape-Copy",
    stroke: "#000000",
    strokeWidth: 1.2,
    transform: "translate(36.000000, 20.000000) scale(-1, 1) translate(-36.000000, -20.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(51.000000, 8.000000)",
    fill: "#000000",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 20,
    fontWeight: 600,
    letterSpacing: -0.166666667,
    "line-spacing": 24
  }, /*#__PURE__*/React.createElement("text", {
    id: "ReDI-Connect"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "ReDI Connect"))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FD4D00",
    cx: 9.5,
    cy: 20.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#000000",
    strokeWidth: 1.2,
    cx: 15.5,
    cy: 20.5,
    r: 8.9
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTg3cHgiIGhlaWdodD0iNDBweCIgdmlld0JveD0iMCAwIDE4NyA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNjMuMSAoOTI0NTIpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPgogICAgPHRpdGxlPkxvZ28vTC9WMDM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iTG9nby9ML1YwMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTM5Ljc5ODk4OTksLTUuODA4Njg2ODZlLTEzIEwzOS43OTg5ODk5LDM5LjU5Nzk3OTcgTDIwLDE5Ljc5ODk4OTkgTDM5Ljc5ODk4OTksLTUuODA4Njg2ODZlLTEzIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iIzJDQjBDNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkuODk5NDk1LCAxOS43OTg5OTApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTI5Ljg5OTQ5NSwgLTE5Ljc5ODk5MCkgIj48L3BhdGg+CiAgICAgICAgPHBhdGggZD0iTTQ1LjEyNSwxLjcyMjU4MDA2IEwyNi44NDg1MTc0LDE5Ljk5OTk4OTIgTDQ1LjEyNSwzOC4yNzY0NzE5IEw0NS4xMjUsMS43MjI1ODAwNiBaIiBpZD0iQ29tYmluZWQtU2hhcGUtQ29weSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYuMDAwMDAwLCAyMC4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTM2LjAwMDAwMCwgLTIwLjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgPGcgaWQ9Ikdyb3VwLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUxLjAwMDAwMCwgOC4wMDAwMDApIiBmaWxsPSIjMDAwMDAwIiBmb250LWZhbWlseT0iQXZlbmlyLUhlYXZ5LCBBdmVuaXIiIGZvbnQtc2l6ZT0iMjAiIGZvbnQtd2VpZ2h0PSI2MDAiIGxldHRlci1zcGFjaW5nPSItMC4xNjY2NjY2NjciIGxpbmUtc3BhY2luZz0iMjQiPgogICAgICAgICAgICA8dGV4dCBpZD0iUmVESS1Db25uZWN0Ij4KICAgICAgICAgICAgICAgIDx0c3BhbiB4PSIwIiB5PSIyMCI+UmVESSBDb25uZWN0PC90c3Bhbj4KICAgICAgICAgICAgPC90ZXh0PgogICAgICAgIDwvZz4KICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjRkQ0RDAwIiBjeD0iOS41IiBjeT0iMjAuNSIgcj0iOS41Ij48L2NpcmNsZT4KICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLUNvcHkiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjIiIGN4PSIxNS41IiBjeT0iMjAuNSIgcj0iOC45Ij48L2NpcmNsZT4KICAgIDwvZz4KPC9zdmc+";